import task from "@commons/task";
import {sa2Toast, sa2Confirm, sa2Alert} from "@commons/sa2Custom";
import {__t} from "@commons/i18nRef";

var groupsElement = $("#groupId"); // Classe riferimento
var couponElement = $("#product-subscription-coupon"); // Classe riferimento
var btnElement = $(couponElement).next().find(".btn-verify-coupon");
var btnSpinner = $(btnElement).find(".spinner-grow");

if ($(couponElement).length && $(btnElement).length) {

    $(btnElement).on("click", function (e) {
        e.preventDefault();

        var groupId = $(groupsElement).val();
        var code = $(couponElement).val();
        var businessMoment = $(couponElement).data("moment");

        if (!code) {
            return;
        }

        if (!groupId) {
            sa2Alert(__t("Seleziona il gruppo"));
        }

        $(btnSpinner).removeClass("d-not");
        $(btnElement).prop("disable", true);

        $.post(task("Register.validateCoupon"), {groupId: groupId, code: code, businessMoment: businessMoment}, function (response) {

            sa2Alert(response.message, (response.success) ? "success" : "warning");

        }, 'json').fail(function (xhr, status, error) {

        }).always(function () {
            $(btnSpinner).addClass("d-not");
            $(btnElement).prop("disable", false);
        });

    });

}


